import backend from '@common/backend';

const BASE = '/media';

export interface IMediaFile {
	original_name: string;
	size: number;
	url: string;
}

interface MediaResponse {
	url: string;
	file: IMediaFile;
}

interface DeleteMedia {
	id: number;
	entity: 'users' | 'polices';
	media_collection: 'avatar' | 'image';
}

export const postMedia = async (
	file: File | Blob,
	onProgress?: (progress: number) => void,
): Promise<MediaResponse> => backend.uploadFile(file, onProgress) as Promise<MediaResponse>;

export const deleteMedia = async (data: DeleteMedia) => backend.delete(`${BASE}`, data);
